import { Dropdown, Input, Menu, Space } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleModal } from "../../slices/modalSlice";
import { Link } from "react-router-dom";
import {
  DarkMode,
  MenuIcon,
  MessageIcon,
  NotificationIcon,
  SearchIcon,
} from "../../utils/icons";
import { SmileOutlined } from "@ant-design/icons";

function AppBar() {
  const dispatch = useDispatch();
  const [menuColor, setMenuColor] = useState("#8F8F8F");
  const notification = useSelector((state) => state.socket.notifications);

  console.log({ notification });

  const menu = (
    <Menu className="h-96 w-72 overflow-y-auto">
      {notification.map((notification, index) => (
        <Menu.Item key={index}>
          <div>
            <div>{notification.Message}</div>
            <div style={{ fontSize: "12px", color: "#999" }}>
              {new Date(notification.CreatedAt).toLocaleString()}
            </div>
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );
  return (
    <div className="AppBar_style flex items-center justify-between bg-slate-50 rounded-3xl px-5 gap-2 mb-5">
      <div className="flex items-center gap-5">
        <p>Welcome</p>
        <Input
          // style={{ width: "600px" }}
          className="bg-pureWhite rounded-3xl border-none px-5 py-2"
          placeholder="Search"
          suffix={<SearchIcon />}
        />
      </div>
      <div className="flex">
        <DarkMode />
        <a
          className="cursor-pointer"
          onMouseEnter={() => setMenuColor("#FF6B38")}
          onMouseLeave={() => setMenuColor("#8F8F8F")}
          onClick={() => dispatch(toggleModal())}
        >
          <MenuIcon color={menuColor} />
        </a>
        <Link to={"/communication"}>
          <MessageIcon />
        </Link>
        <Dropdown
          overlay={menu}
          trigger={["hover"]}
          className="cursor-pointer rounded-xl"
          placement="bottomRight"
          arrow
          overlayClassName="rounded-xl"
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              <NotificationIcon />
            </Space>
          </a>
        </Dropdown>
      </div>
    </div>
  );
}

export default AppBar;
